/* eslint-disable */
// @ts-nocheck
import * as Types from '../../types.generated.js';

import { GetBlogPostBySlugAuthorFragmentFragmentDoc, GetBlogPostBySlugImageFragmentFragmentDoc, GetBlogPostBySlugTagsFragmentFragmentDoc, GetBlogPostBySlugSeoFragmentFragmentDoc, GetBlogPostBySlugCategoryFragmentFragmentDoc, GetBlogCategoriesPostPaginationFragmentFragmentDoc, GetBlogCategoriesPaginationFragmentFragmentDoc } from './blog-post-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { customFetcher } from 'libs/data-access/src/lib/custom-fetcher/';
export type GetAllBlogPostsQueryVariables = Types.Exact<{
  input: Types.BlogPostQueryArgs;
}>;


export type GetAllBlogPostsQuery = { __typename?: 'Query', getAllBlogPosts: { __typename?: 'PostAttributesData', data?: Array<{ __typename?: 'FullPostAttributes', article?: string | null, resume?: string | null, slug?: string | null, title?: string | null, readingTime?: number | null, id?: string | null, authors?: Array<{ __typename?: 'Author', name?: string | null, picture?: { __typename?: 'Media', url?: string | null } | null }> | null, featuredImage?: { __typename?: 'Image', authorName?: string | null, authorPortfolio?: string | null, siteLink?: string | null, siteOfImage?: string | null, image?: { __typename?: 'Media', url?: string | null, formats?: { __typename?: 'Formats', overwrittenLarge?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenMedium?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenSmall?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenThumbnail?: { __typename?: 'MediaFormat', url?: string | null } | null } | null } | null } | null, tags?: Array<{ __typename?: 'Tag', name?: string | null }> | null, seo?: { __typename?: 'SEO', id?: string | null, keywords?: string | null, metaDescription?: string | null, metaTitle?: string | null, metaSocial?: { __typename?: 'MetaSocial', description?: string | null, id?: string | null, title?: string | null, image?: { __typename?: 'Media', alternativeText?: string | null, height?: number | null, mime?: string | null, url?: string | null, width?: number | null, formats?: { __typename?: 'Formats', large?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, medium?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, small?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, thumbnail?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null } | null } | null } | null } | null, category?: { __typename?: 'Category', name?: string | null } | null }> | null, pagination?: { __typename?: 'Pagination', page?: number | null, pageCount?: number | null, pageSize?: number | null, total?: number | null } | null } };


export const GetAllBlogPostsDocument = /*#__PURE__*/ `
    query GetAllBlogPosts($input: BlogPostQueryArgs!) {
  getAllBlogPosts(input: $input) {
    data {
      article
      resume
      slug
      title
      readingTime
      ...GetBlogPostBySlugAuthorFragment
      ...GetBlogPostBySlugImageFragment
      ...GetBlogPostBySlugTagsFragment
      ...GetBlogPostBySlugSeoFragment
      ...GetBlogPostBySlugCategoryFragment
      id
    }
    pagination {
      page
      pageCount
      pageSize
      total
    }
  }
}
    ${GetBlogPostBySlugAuthorFragmentFragmentDoc}
${GetBlogPostBySlugImageFragmentFragmentDoc}
${GetBlogPostBySlugTagsFragmentFragmentDoc}
${GetBlogPostBySlugSeoFragmentFragmentDoc}
${GetBlogPostBySlugCategoryFragmentFragmentDoc}`;
export const useGetAllBlogPostsQuery = <
      TData = GetAllBlogPostsQuery,
      TError = {extensions: {code: string, serviceName: string, exception: Record<string, unknown>}, message: string}
    >(
      variables: GetAllBlogPostsQueryVariables,
      options?: UseQueryOptions<GetAllBlogPostsQuery, TError, TData>
    ) =>
    useQuery<GetAllBlogPostsQuery, TError, TData>(
      ['GetAllBlogPosts', variables],
      customFetcher<GetAllBlogPostsQuery, GetAllBlogPostsQueryVariables>(GetAllBlogPostsDocument, variables),
      options
    );

useGetAllBlogPostsQuery.getKey = (variables: GetAllBlogPostsQueryVariables) => ['GetAllBlogPosts', variables];
;

export const useInfiniteGetAllBlogPostsQuery = <
      TData = GetAllBlogPostsQuery,
      TError = {extensions: {code: string, serviceName: string, exception: Record<string, unknown>}, message: string}
    >(
      variables: GetAllBlogPostsQueryVariables,
      options?: UseInfiniteQueryOptions<GetAllBlogPostsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAllBlogPostsQuery, TError, TData>(
      ['GetAllBlogPosts.infinite', variables],
      (metaData) => customFetcher<GetAllBlogPostsQuery, GetAllBlogPostsQueryVariables>(GetAllBlogPostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetAllBlogPostsQuery.getKey = (variables: GetAllBlogPostsQueryVariables) => ['GetAllBlogPosts.infinite', variables];
;

useGetAllBlogPostsQuery.fetcher = (variables: GetAllBlogPostsQueryVariables, options?: RequestInit['headers']) => customFetcher<GetAllBlogPostsQuery, GetAllBlogPostsQueryVariables>(GetAllBlogPostsDocument, variables, options);